// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bottomAd_box":"bottomAd_box-2ZQvEKSY","bottomAd":"bottomAd-WxK8_tJ6"};